<div class="container">
  
  <div class="header-top">
    <div class="header-left">
      <app-page-close-button (click)="goBack()"></app-page-close-button>
      <div class="title-container">
        <span class="title">
          @if (readOnlyMode) { View } @else if (editMode) { Edit }
          @else { Add } Vendor
        </span>
      </div>
    </div>
    <div class="header-right">
      <ng-container *ngIf="!readOnlyMode">
        <button type="button" class="secondary_button" (click)="goBack()">
          Cancel
        </button>
        <button
          type="button"
          class="primary_button"
          (click)="submitMasterForm()"
        >
          @if(editMode) { Update } @else { Save }
        </button>
      </ng-container>
    </div>
  </div>

  <app-horizontal-tabs
    [tabs]="tabList"
    [selectedTab]="selectedTab"
    (tabSelected)="selectTab($event)"
  ></app-horizontal-tabs>


  <div class="container-content">
    <form [formGroup]="masterForm">
      <div class="vendor-section" [hidden]="selectedTab !== 'vendorSection'">
          <app-section-header
            [title]="'Vendor Information'"
            [subtitle]="'Basic information about the vendor.'"
          ></app-section-header>

          <div class="form-container card-layout">
            
            <div class="form-row">
              
              <div class="form-item">
                <label for="code" class="required_field_label" #formField>Vendor Code</label>
                <input id="code" name="code" formControlName="code" type="text" placeholder="Enter code" required
                  autocomplete="code" />
                  <div class="form_validation_error_new" [ngClass]="{'visible': masterForm.get('code')?.invalid && masterForm.get('code')?.touched}">
                    <small *ngIf="masterForm.get('code')?.errors?.['required']">Vendor Code is required</small>
                  </div>
              </div>

              <div class="form-item">
                <label for="name" class="required_field_label" #formField>Vendor Name</label>
                <input id="name" name="name" formControlName="name" type="text" placeholder="Enter name" required autocomplete="name">
                <div class="form_validation_error_new" [ngClass]="{'visible': masterForm.get('name')?.invalid && masterForm.get('name')?.touched}">
                  <small *ngIf="masterForm.get('name')?.errors?.['required']">Vendor Name is required</small>
                </div>
              </div>
          
              <div class="form-item">
                <label for="panNumber" class="required_field_label" #formField>PAN Number</label>
                <input id="panNumber" name="panNumber" formControlName="panNumber" type="text" uppercaseInput
                  placeholder="Enter PAN Number" />
                  <div class="form_validation_error_new" [ngClass]="{'visible': masterForm.get('panNumber')?.invalid && masterForm.get('panNumber')?.touched}">
                    <small *ngIf="masterForm.get('panNumber')?.errors?.['required']">PAN Number is required</small>
                    <small *ngIf="masterForm.get('panNumber')?.errors?.['pattern']">Invalid PAN Number</small>
                  </div>
              </div>

            </div>

            <div class="form-row">

              <div class="form-item">
                <label for="agreementWorkOrderNo" class="required_field_label" #formField>Agreement Work Order No.</label>
                <input id="agreementWorkOrderNo" name="agreementWorkOrderNo" formControlName="agreementWorkOrderNo" type="text" placeholder="Enter Agreement Work Order No." />
                  <div class="form_validation_error_new" [ngClass]="{'visible': masterForm.get('agreementWorkOrderNo')?.invalid && masterForm.get('agreementWorkOrderNo')?.touched}">
                    <small *ngIf="masterForm.get('agreementWorkOrderNo')?.errors?.['required']">Agreement/Work Order No. is required</small>
                  </div>
              </div>

              <div class="form-item">
                <label for="agreementStartDate" class="required_field_label" #formField>Agreement Start Date</label>
                <app-date-picker
                    [id]="'agreementStartDate'" 
                    [type]="'date'" 
                    [formControlName]="'agreementStartDate'" 
                    [placeholder]="'Select Agreement Start Date'" 
                    [required]="true">
                </app-date-picker>
                <div class="form_validation_error_new" [ngClass]="{'visible': masterForm.get('agreementStartDate')?.invalid && masterForm.get('agreementStartDate')?.touched}">
                  <small *ngIf="masterForm.get('agreementStartDate')?.errors?.['required']">Agreement Start Date is required</small>
                </div>
              </div>

              <div class="form-item">
                <label for="agreementEndDate" class="required_field_label" #formField>Agreement End Date</label>
                <app-date-picker
                    [id]="'agreementEndDate'" 
                    [type]="'date'" 
                    [formControlName]="'agreementEndDate'" 
                    [placeholder]="'Select Agreement End Date'" 
                    [required]="true">
                </app-date-picker>
                <div class="form_validation_error_new" [ngClass]="{'visible': masterForm.get('agreementEndDate')?.invalid && masterForm.get('agreementEndDate')?.touched}">
                  <small *ngIf="masterForm.get('agreementEndDate')?.errors?.['required']">Agreement End Date is required</small>
                </div>
              </div>

            </div>

            <div class="form-row">
              <div class="form-item">
                <label for="creditDays" class="required_field_label" #formField>Credit Days</label>
                <input id="creditDays" name="creditDays" formControlName="creditDays" type="number" placeholder="Enter Credit Days" min="0" />
                <div class="form_validation_error_new" [ngClass]="{'visible': masterForm.get('creditDays')?.invalid && masterForm.get('creditDays')?.touched}">
                  <small *ngIf="masterForm.get('creditDays')?.errors?.['required']">Credit Days is required</small>
                </div>
              </div>

              <div class="form-item">
                <label for="creditLimit" class="required_field_label" #formField>Credit Limit</label>
                <input id="creditLimit" name="creditLimit" formControlName="creditLimit" type="number" placeholder="Enter Credit Limit" min="0" />
                <div class="form_validation_error_new" [ngClass]="{'visible': masterForm.get('creditLimit')?.invalid && masterForm.get('creditLimit')?.touched}">
                  <small *ngIf="masterForm.get('creditLimit')?.errors?.['required']">Credit Limit is required</small>
                </div>
              </div>
            </div>

            <div class="form-row">
              <div class="form-item">
                <label for="vendorStatus" class="required_field_label" #formField>Vendor Status</label>
                <app-multi-select
                  [options]="vendorStatusOptions"
                  [returnRawValue]="false"
                  [displayKey]="'name'"
                  [valueKey]="'value'"
                  [isMultiSelect]="false"
                  [placeholder]="'Select Vendor Status'"
                  [formControlName]="'vendorStatus'"
                  [required]="true"
                  (selectionChange)="onVendorStatusChange($event.value)"
                >
                </app-multi-select>
                <div class="form_validation_error_new" [ngClass]="{'visible': masterForm.get('vendorStatus')?.invalid && masterForm.get('vendorStatus')?.touched}">
                  <small *ngIf="masterForm.get('vendorStatus')?.errors?.['required']">Vendor Status is required</small>
                </div>
              </div>

              <div class="form-item" *ngIf="masterForm.get('vendorStatus')?.value === 'OTHER'">
                <label for="otherStatusValue" class="required_field_label" #formField>Vendor Status (Others)</label>
                <input id="otherStatusValue" name="otherStatusValue" formControlName="otherStatusValue" type="text" placeholder="Specify Vendor Status" />
                <div class="form_validation_error_new" [ngClass]="{'visible': masterForm.get('otherStatusValue')?.invalid && masterForm.get('otherStatusValue')?.touched}">
                  <small *ngIf="masterForm.get('otherStatusValue')?.errors?.['required']">Vendor Status value is required</small>
                  <small *ngIf="masterForm.get('otherStatusValue')?.errors?.['maxlength']">Max 30 characters allowed</small>
                </div>
              </div>

              <div class="form-item" *ngIf="masterForm.get('vendorStatus')?.value !== 'OTHER'">
                <label for="identityNo" class="required_field_label" #formField>Identity Number</label>
                <input id="identityNo" name="identityNo" formControlName="identityNo" type="text" placeholder="Enter Identity Number" />
                <div class="form_validation_error_new" [ngClass]="{'visible': masterForm.get('identityNo')?.invalid && masterForm.get('identityNo')?.touched}">
                  <small *ngIf="masterForm.get('identityNo')?.errors?.['required']">Identity Number is required</small>
                  <small *ngIf="masterForm.get('identityNo')?.errors?.['maxlength']">Max 20 characters allowed</small>
                </div>
              </div>
            </div>

            <app-file-upload
            [title]="'Upload Agreement & Other files'"
            [(files)]="fileList"
            [allowedFileTypes]="allowedFileTypes"
            [multiFileUpload]="true"
            [disabled]="readOnlyMode"
          ></app-file-upload>

          </div>
      </div>
    </form>

    <div class="contact-section" [hidden]="selectedTab !== 'contactSection'">      
      <div class="header-top contact-header">
        <div class="header-left">
          <span class="section-title">Contacts</span>
        </div>

        <div class="header-right" *ngIf="!readOnlyMode && contactList.length > 0">
          <button type="button" class="tertiary_button" (click)="addContact()">
            <app-svg-icon [path]="'assets/icons/add_plus_icon.svg'"></app-svg-icon>
            Add New Contact</button>
        </div>
      </div>
  
      @if(contactList.length > 0) {
      <div class="contact-list">
          <div class="contact-item" *ngFor="let contact of contactList; let i = index">
            <app-item-card
            [title]="contact.contactName"
            [lines]="getFormattedContactSummary(i)"
            [badges]="getContactBadges(i)"
            [actions]="contactActions"
            (actionClicked)="handleContactAction(i, $event)"
            ></app-item-card>
          </div>
      </div>
      } @else {
        <div class="empty-state-container">
          <app-no-data [msg]="'No contacts added yet'" [path]="'assets/icons/empty_contacts_icon.svg'"></app-no-data>
          <button type="button" class="tertiary_button" *ngIf="!readOnlyMode" (click)="addContact()">
            <app-svg-icon [path]="'assets/icons/add_plus_icon.svg'"></app-svg-icon>
            Add New Contact</button>
        </div>
      }
    </div>

    <div class="service-container" [hidden]="selectedTab !== 'serviceSection'">
        <div class="section-title">
          @if (readOnlyMode && serviceList.length > 0) {
          <span>Selected Service(s)</span>
          } @else if (readOnlyMode) {
          <span>No Service(s) selected</span>
          } @else {
          <span>Add Service(s)</span>
          }
        </div>

        <div *ngIf="!readOnlyMode" class="search-container">
          <app-autocomplete-dropdown
            id="search-bar"
            class="autocomplete-dropdown"
            [placeholder]="'Search and add Service'"
            [apiUrl]="'v1/services/list'"
            [filterByKeys]="['NAME_CONTAINS']"
            [limit]="10"
            [orderBy]="{ name: 'asc' }"
            [bindLabel]="'name'"
            [bindValue]="'id'"
            [displayColumns]="[
              { key: 'name', header: 'Service Name' },
              { key: 'code', header: 'Service Code' }
            ]"
            [additionalFilters]="[
              {
                name: 'active',
                alias: 'active',
                operator: 'EQ',
                value: ['true']
              }
            ]"
            [(ngModel)]="serviceSearchText"
            (suggestionSelected)="onServiceSelected($event)"
          >
          </app-autocomplete-dropdown>
          <button
            type="button"
            class="add-button secondary_button"
            [disabled]="disableAddButton"
            (click)="addSelectedService()"
          >
            <app-svg-icon
              class="image-icon"
              [path]="'assets/icons/add_plus_icon.svg'"
            ></app-svg-icon>
            <span>Add</span>
          </button>
        </div>

        <div class="service-table-container" *ngIf="serviceList.length > 0">
          <table class="table-view-data">
            <thead>
              <tr>
                <th><span>Sl No</span></th>
                <th><span>Service Name</span></th>
                <th><span>Active</span></th>
                <th><span>Make this Vendor default?</span></th>
                <th class="delete_column" *ngIf="!readOnlyMode"><span></span></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let result of serviceList; let i = index">
                <td>
                  <span>{{ i + 1 }}</span>
                </td>
                <td class="primary_column">
                  <span>{{ result?.serviceMetadata?.name }}</span>
                </td>
                <td>
                  <span>{{ result?.serviceMetadata?.active ? "Yes" : "No" }}</span>
                </td>
                <td class="checkbox_column">
                  <input
                    type="checkbox"
                    (click)="selectVendorAsDefault(i)"
                    [readOnly]="readOnlyMode"
                    [checked]="result.default ?? false"
                  />
                </td>
                <td *ngIf="!readOnlyMode" class="delete_column">
                  <div class="icon-container">
                    <app-svg-icon
                      class="delete-icon"
                      [path]="'assets/icons/delete_icon.svg'"
                      (click)="removeService(i)"
                    ></app-svg-icon>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
    </div>
  </div>
</div>
